// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d6721f42","952":"53a527b9"}[chunkId] + ".chunk.js";
};